var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tabs",
    { attrs: { pills: "", card: "", vertical: "" } },
    _vm._l(_vm.days, function (day, idx) {
      return _c(
        "b-tab",
        { key: idx, attrs: { "title-link-class": "", active: day.is_active } },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "fs-lg px-4 text-center" }, [
              _vm._v(
                "\n                " + _vm._s(day.name) + "\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-card-text",
            [
              _c(_vm.day_component, {
                tag: "component",
                attrs: { times: day.times, cur_idx: idx },
              }),
            ],
            1
          ),
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }